import { Outlet } from "react-router-dom";
import { useNotificationWebsocket } from "@bsm/notification";

const HareaContainer = () => {
    useNotificationWebsocket();

    return <Outlet />;
};

export default HareaContainer;
